module.exports = __webpack_public_path__ + "img/gemini-market-chart.2bf01713.webp";